import { db_loading_type } from "../interfaces";

// ██╗███╗   ██╗██████╗ ███████╗██╗  ██╗███████╗██████╗ ██████╗ ██████╗
// ██║████╗  ██║██╔══██╗██╔════╝╚██╗██╔╝██╔════╝██╔══██╗██╔══██╗██╔══██╗
// ██║██╔██╗ ██║██║  ██║█████╗   ╚███╔╝ █████╗  ██║  ██║██║  ██║██████╔╝
// ██║██║╚██╗██║██║  ██║██╔══╝   ██╔██╗ ██╔══╝  ██║  ██║██║  ██║██╔══██╗
// ██║██║ ╚████║██████╔╝███████╗██╔╝ ██╗███████╗██████╔╝██████╔╝██████╔╝
// ╚═╝╚═╝  ╚═══╝╚═════╝ ╚══════╝╚═╝  ╚═╝╚══════╝╚═════╝ ╚═════╝ ╚═════╝
//                              IndexedDB

export const db_loading: db_loading_type = {};
